import { render } from "./VerifyEmail.vue?vue&type=template&id=ac49c30c"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
script.render = render

export default script